import "./App.css";
import RoutesWrapper from "./RoutesWrapper";

function App() {
  return (
    <div className="App">
      <RoutesWrapper />
    </div>
  );
}

export default App;
